import { REPLACE_SELLERS, CLEAR_SELLERS, SET_SELLERS_PAGESIZE, SET_SELLERS_PAGENUMBER, SET_SELLERS_TEXTFIELD } from './actions';

const initialState = {
    sellers: [],
    totalResults: 0,
    totalPage: 1,
    pageSize: 10,
    pageNumber: 1,
    textField: ''
}

export default function main (state = initialState, action) {
    switch (action.type) {
        case REPLACE_SELLERS:
            return {
                ...state,
                sellers: action.sellers,
                totalResults: action.totalResults,
                totalPage: action.totalPage
            }
        case SET_SELLERS_PAGESIZE:
            return {
                ...state,
                pageSize: action.pageSize
            }
        case SET_SELLERS_PAGENUMBER:
            return {
                ...state,
                pageNumber: action.pageNumber
            }
        case SET_SELLERS_TEXTFIELD:
            return {
                ...state,
                pageNumber: 1,
                textField: action.textField
            }
        case CLEAR_SELLERS:
            return initialState
        default:
            return state;
    }
}